// src/services/customerService.jsx
import axiosInstance from './axiosConfig';

const customerService = {
  getAll: async (page = 1, limit = 10) => {
    const response = await axiosInstance.get(`/customers?page=${page}&limit=${limit}`);
    return response.data.data ?? response.data;
  },

  getById: async (id) => {
    const response = await axiosInstance.get(`/customers/${id}`);
    return response.data.data ?? response.data;
  },

  getAvailableRoutes: async () => {
    const response = await axiosInstance.get('/routes/available');
    return response.data.data ?? response.data;
  },

  create: async (payload) => {
    const response = await axiosInstance.post('/customers/create', payload);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axiosInstance.put(`/customers/edit/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axiosInstance.delete(`/customers/delete/${id}`);
    return response.data;
  },
};

export default customerService;
